import axios from 'axios'
import base from '../../../base'
import resource from '../resource'
import { REQUEST_DATA_SUCCESS } from './mutation-types'

export default {
  requestData({ commit }) {
    const config = {
      url: `${resource}/dados`,
      baseURL: base
    }

    return axios(config).then(({ data }) => {
      commit(REQUEST_DATA_SUCCESS, data)
    })
  },
  submitData(_, payload) {
    const config = {
      method: 'put',
      url: `${resource}/update`,
      baseURL: base,
      data: payload
    }

    return axios(config)
  }
}
